import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporterProcess(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/finances/harvested_batch_outcomes/${agro_exporter_id}/show_process/${agro_exporter_process_id}`
    );
  },
  fetchOrgInvoices(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/finances/harvested_batch_outcomes/${agro_exporter_id}/show_process/fetch_org_invoices/${agro_exporter_process_id}`
    );
  },
  downloadRepXlsx(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/finances/harvested_batch_outcomes/${agro_exporter_id}/show_process/download_rep_xlsx/${agro_exporter_process_id}`,
      { responseType: "blob" }
    );
  },
};
